import { Flex, Typography } from "antd"
import React from "react"
import { Outlet } from "react-router-dom"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import SettingsLayoutTabs from "./SettingsLayoutTabs.tsx"

const { Title } = Typography

export function SettingsLayout() {
  const moduleAccess = useAppSelector(
    (state) => state?.auth?.userInfo?.permissions?.codes
  )

  return (
    <Flex vertical gap={"middle"} className={"size-full -mt-2"}>
      {/* `top-0`, not `top-16`: this used to stick relative to the whole
          page's own scroll, sharing one coordinate system with the app
          header above it (also sticky, `top-0`) — so clearing the header's
          64px meant an explicit `top-16` offset here. `#main-content` (the
          shell's content column) is now its OWN scrolling container, and it
          already starts right below the header in the page's layout — so
          this div's nearest scrolling ancestor is `#main-content` itself,
          whose own top edge IS "right below the header" with no further
          offset needed. The old `top-16` doubled that clearance instead,
          which is what pushed this title into the scrolled table content
          below it (confirmed live). */}
      <div className={"sticky top-0 bg-background z-10 pt-2"}>
        <Flex justify={"space-between"}>
          <Title className={"text-start"} level={2}>
            Settings
          </Title>
        </Flex>
        <SettingsLayoutTabs permissions={moduleAccess} />
      </div>
      <Flex flex={1}>
        <Outlet />
      </Flex>
    </Flex>
  )
}
